export const formatInStockResponse = (input) => {
	const data = input.data?.map((item) => {
		return {
			bus_dt: item?.bus_dt,
			wm_wk_nbr: item.wm_wk_nbr,
			wm_yr_wk_nbr: item.wm_yr_wk_nbr,
			ly_value: item.ly_instock,
			ty_value: item.ty_instock,
			omni_catg_nbr: item.omni_catg_nbr,
		};
	});
	return {
		metric: input.metric,
		data,
		summary: {
			total_ty: input?.summary?.total_in_stock,
			diff_perc: input?.summary?.total_in_stock_diff,
		},
	};
};

export const formatInventoryTrendsResponse = (input) => {
	const data = input.data?.map((item) => {
		return {
			...item,
			busDt: item?.busDt,
			calWkDayNm: item.calWkDayNm,
			wmWkNbr: item.wmWkNbr,
			lyValue: item.tyValue2,
			tyValue: item.tyValue1,
			wmYrWkNbr: item.wmYrWkNbr,
		};
	});
	return {
		dimension: input.dimension,
		kpi: input.kpi,
		data,
	};
};
